<!--

-->

<template>
  <div :class="btnClass" class="button fontSemiBold14">{{buttonLabel}}</div>
</template>


<script>
export default {
  name: 'btn',
  components: {
  },
  data() {
    return {
      buttonLabel: this.$props.label ? this.$props.label : 'Mehr',
      btnClass: 'button--labeled',
    };
  },
  props: {
    label: {
      type: String,
      default: () => 'Mehr',
    },
    showLabel: {
      type: Boolean,
      default: () => true,
    },
  },
  watch: {
    showLabel(value) {
      setTimeout(() => {
        // wait for css transition: first show content then change this button
        this.btnClass = value ? 'button--labeled' : 'button--close';
      }, 500);
    },
  },
};
</script>


<style lang="scss" scoped>
  .button {
    display: inline-block;
    color: var(--white);
    background-color: var(--red);
    border-radius: 2rem;
    text-align: center;
    cursor: pointer;
    transition: min-width 0.3s, transform 0.3s;
    height: 16px;
    text-transform: uppercase;
    font-weight: bold;
  }
  .button:hover {
    transform: scale(1.05);
  }

  .button--labeled {
    padding: var(--btnPadding);
    min-width: 9rem;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 2px;
  }

  .button--close {
    color: transparent;
    min-width: 3.5rem;
    height: 3.5rem;
    cursor: pointer;
    margin-top: 1rem;
    background: url("../assets/img/read-btn-close.svg") center / 100% no-repeat;
  }
</style>
